function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import useSetWhenForItems from "@sprout/client-graphql/dist/mutations/useSetWhenForItems";
import { useNavigationListContext } from "@sprout/list-navigation";
import { MenuTrigger, useMenuState } from "@sprout/list-navigation/dist/Menu";
import { useCallback, useMemo } from "react";
import { ItemType } from "sprout-graphql";
import { Button, Scheduler, usePopoverState, Popover, PopoverReference, PopoverTrigger, Deadline as BaseDeadline, usePopoverRegistryHandler } from "sprout-ui-dom";
import { EditOutlined, MoreHoriz, ScheduleOutlined } from "sprout-ui-icons";
import { Flex } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import styled, { css } from "styled-components";
import PostMenu from "./PostMenu";
import usePostAuthorization from "./usePostAuthorization";
const Deadline = styled(BaseDeadline)`
  min-width: 320px;
`;
const PostActionsWrapper = styled(Flex)`
  top: -7px;
  right: 0;
  background-color: #fff;
  box-shadow: 0 1px 20px rgba(0, 0, 0, 0.1);

  ${({ $open  })=>!$open && css`
      display: none;
    `}
`;
const PostActionsButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;

  ${media.target("pointer")} {
    :hover {
      background: #f7fafd;
    }
  }

  :active {
    background: #f7fafd;
  }

  transition: background 0.15s linear;
`;
const PostActions = (props)=>{
    const { post , onActionHandled  } = props;
    const authorization = usePostAuthorization(post);
    const { dispatchCommand , currentlyActiveCommands  } = useNavigationListContext();
    const items = useMemo(()=>[
            post
        ], [
        post
    ]);
    const canEditPost = currentlyActiveCommands.includes("EDIT_POST_DESCRIPTION");
    const canEditTodo = currentlyActiveCommands.includes("EDIT_TODO");
    const canEdit = authorization.edit && (canEditPost || canEditTodo);
    const handleEditClick = useCallback(()=>{
        dispatchCommand(post.type === ItemType.Post ? "EDIT_POST_DESCRIPTION" : "EDIT_TODO", post);
    }, [
        dispatchCommand,
        post
    ]);
    const menuState = useMenuState();
    const setWhenForItems = useSetWhenForItems();
    //
    const schedulerPopoverState = usePopoverState();
    const { onOpen: openScheduler , onClose: closeScheduler  } = schedulerPopoverState;
    const handleScheduled = useCallback(({ when , whenReminder  })=>{
        closeScheduler();
        setWhenForItems({
            items: [
                post
            ],
            when,
            whenReminder
        });
        if (onActionHandled) onActionHandled({
            item: post,
            action: "schedule",
            when,
            deadline: post.deadline
        });
    }, [
        closeScheduler,
        onActionHandled,
        post,
        setWhenForItems
    ]);
    //
    const deadlinePopoverState = usePopoverState();
    const { onOpen: openDeadline , onClose: closeDeadline  } = deadlinePopoverState;
    const handleSetDeadline = useCallback(({ deadline  })=>{
        closeDeadline();
        setWhenForItems({
            items: items,
            deadline
        });
        if (onActionHandled) onActionHandled({
            item: post,
            action: "deadline",
            when: post.when,
            deadline
        });
    }, [
        closeDeadline,
        items,
        onActionHandled,
        post,
        setWhenForItems
    ]);
    //
    usePopoverRegistryHandler(`${post.id}#when`, {
        onOpen: openScheduler,
        onClose: closeScheduler
    });
    usePopoverRegistryHandler(`${post.id}#deadline`, {
        onOpen: openDeadline,
        onClose: closeDeadline
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Popover, _objectSpread({}, schedulerPopoverState, {
                children: /*#__PURE__*/ _jsx(Scheduler, {
                    items: items,
                    onScheduled: handleScheduled,
                    onEscape: closeScheduler
                })
            })),
            /*#__PURE__*/ _jsx(Popover, _objectSpread({}, deadlinePopoverState, {
                children: /*#__PURE__*/ _jsx(Deadline, {
                    items: items,
                    onSetDeadline: handleSetDeadline,
                    onEscape: closeDeadline
                })
            })),
            /*#__PURE__*/ _jsx(PostMenu, {
                menuState: menuState,
                post: post
            }),
            /*#__PURE__*/ _jsxs(PostActionsWrapper, {
                alignItems: "center",
                position: "absolute",
                // bg="blue.40"
                borderRadius: "8px",
                p: "2px",
                zIndex: 1,
                className: "PostActions",
                $open: menuState.open !== false || schedulerPopoverState.open || deadlinePopoverState.open,
                children: [
                    authorization.schedule && /*#__PURE__*/ _jsx(PopoverReference, _objectSpread({}, schedulerPopoverState, {
                        children: /*#__PURE__*/ _jsx(PopoverTrigger, _objectSpread({}, schedulerPopoverState, {
                            children: /*#__PURE__*/ _jsx(PostActionsButton, {
                                children: /*#__PURE__*/ _jsx(ScheduleOutlined, {})
                            })
                        }))
                    })),
                    canEdit && /*#__PURE__*/ _jsx(PostActionsButton, {
                        onClick: handleEditClick,
                        children: /*#__PURE__*/ _jsx(EditOutlined, {})
                    }),
                    /*#__PURE__*/ _jsx(PopoverReference, _objectSpread({}, deadlinePopoverState, {
                        children: /*#__PURE__*/ _jsx(MenuTrigger, _objectSpread({}, menuState, {
                            children: /*#__PURE__*/ _jsx(PostActionsButton, {
                                children: /*#__PURE__*/ _jsx(MoreHoriz, {})
                            })
                        }))
                    }))
                ]
            })
        ]
    });
};
export default PostActions;
